export interface ConversationStorage {
  read: () => string | null;
  save: (id: string | null) => void;
}

export const createConversationStorage = ({ key, scope }: { key: string; scope?: string }): ConversationStorage => ({
  read: () => {
    try {
      const value = sessionStorage.getItem(key);
      if (value === null || scope === undefined) {
        return value;
      }
      const prefix = `${scope}:`;
      if (value.startsWith(prefix)) {
        return value.slice(prefix.length);
      }
      sessionStorage.removeItem(key);
      return null;
    } catch {
      return null;
    }
  },
  save: (id) => {
    try {
      if (id) {
        sessionStorage.setItem(key, scope === undefined ? id : `${scope}:${id}`);
      } else {
        sessionStorage.removeItem(key);
      }
    } catch {
      // Restricted browser storage must not prevent a member from using chat.
    }
  },
});
